import { useEffect } from 'react';

interface MetaPixelScriptProps {
	metaPixelId: string;
}

const LOADER_ID = 'fbq-loader';

export function MetaPixelScript({ metaPixelId }: MetaPixelScriptProps) {
	const useMeta = !!metaPixelId?.length;

	useEffect(() => {
		if (!useMeta) return;
		if (document.getElementById(LOADER_ID)) return;
		const script = document.createElement('script');
		script.id = LOADER_ID;
		script.async = true;
		script.src = 'https://connect.facebook.net/en_US/fbevents.js';
		document.head.appendChild(script);
	}, [useMeta]);

	return useMeta ? (
		<script
			id="fbq-init"
			dangerouslySetInnerHTML={{
				__html: `
					!function(f,b,e,v,n,t,s){
						if(f.fbq)return;
						n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
						if(!f._fbq)f._fbq=n;
						n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];
					}(window,document,'script');
					fbq('init', '${metaPixelId}');
					fbq('track', 'PageView');
				`,
			}}
		/>
	) : null;
}
